import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories, deleteCategory, changeActiveStatus } from './categorySlice';
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
import { useNavigate, useLocation } from "react-router-dom";
// import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from '../../components/commonTable';
// import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";
import CategoryAdd from './CategoryAdd';
import CategoryEdit from './CategoryEdit';
import CategoryView from './CategoryView';

const CategoryList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { categories } = useSelector((state) => state.categories);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(categories?.total_records / limit);
  const total = categories?.total_records || 0;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialPage = parseInt(params.get("page") || "1");
  const [currentPage, setCurrentPage] = useState(initialPage);

  const token = localStorage.getItem('auth-token');

  let categoryMessage = localStorage.getItem('category_notify_message');

  useEffect(() => {
    if (categoryMessage) {
      setSnackbarMessage(categoryMessage);
      setSnackbarVariant("success");
      setShowSnackbar(true);
      localStorage.removeItem('category_notify_message');
    }
  }, [categoryMessage])

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      const payload = {
        page: currentPage,
        search: searchTerm,
        limit: limit,
        token
      };
  
      try {
        if (token) {
          await dispatch(getCategories({ payload }));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchCategories();
  }, [dispatch, token, currentPage, searchTerm, setLoading]);
  

  const columns = [
    // { label: 'ID', key: 'id' },
    {label: 'Image', key: 'category_image', type: 'image' },
    { label: "Name", key: "category_name", type: "" },
    // { label: "Name", key: "subcategoriesinfo", type: "custom" },
    { label: "Child Categories", key: "subcategoriesinfo", type: "custom" },
    // { label: 'Name', key: 'category_name' },
    // { label: 'Parent Category', key: 'parent_category.category_name' },
    // {label: 'Banner Image', key: 'category_banner_image', type: 'image' },
    {label: 'Attribute Count', key: 'attribute_groups_count'},
    { label: 'created at', key: 'created_at', type: 'date' },
    {label: 'Status', key: 'is_active', type: 'status' },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
    navigate(`/categories?page=${newPageNumber}`);
  };

  const handleDeleteNew = async () => {
    if (selectedCategoryId) {
      await dispatch(deleteCategory(selectedCategoryId)).then((res) => {
        if(res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token
          };
          dispatch(getCategories({ payload }));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    // setSelectedCategoryId(row.id);
    navigate(`/category-edit/${row.id}?page=${currentPage}`);
    // handleOpen();

  };

  // const handleOpen = () => {
  //   setTimeout(() => {
  //     setShowEditModal(true);
  //   }, 1000);
  // };
  

  const handleDelete = (row) => {
    setSelectedCategoryId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedCategoryId(row.id);
    setShowViewModal(true);
  };

  const handleStatusChange = async (row) => {
    setSelectedCategoryId(row.id);
    setShowStatusModal(true);
  }

  const handleStatusChangeNew = async () => {
    await dispatch(changeActiveStatus(selectedCategoryId)).then((res) => {
      if(res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          page: currentPage,
          search: searchTerm,
          limit: limit,
          token
        };
        dispatch(getCategories({ payload }));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  }

    useEffect(() => {
    localStorage.removeItem("category_id_stack");
  }, []);

  useEffect(() => {
    if (initialPage) {
      setCurrentPage(initialPage);
    }     
  }, [initialPage])

  return (
    <>
      <Container fluid className="px-0">
        <CategoryAdd 
          show={showModal}
          // onHide={() => setShowModal(false)}
          handleClose={() => setShowModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <CategoryEdit
          categoryId={selectedCategoryId}
          show={showEditModal}
          // onHide={() => setShowEditModal(false)}
          handleClose={() => setShowEditModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <CategoryView
          show={showViewModal}
          handleClose={() => setShowViewModal(false)}
          categoryId={selectedCategoryId} 
        />

        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this category?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change status?</Modal.Body>
          <Modal.Body><span className='text-danger'>Warning:- Deactivating category may impact on website.</span></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search Category"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="shadow-none base-search"
          />

          {/* <CommonButton
            icon={<Add01Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Add Category"
            className="btn-primary common-one-shadow"
            onClick={() => {
              // setShowModal(true);
              navigate("/category-add");
            }}
          /> */}
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
            <CommonTable
              columns={columns}
              data={categories?.data || []}
              url={categories?.url || []}
              showActions={true}
              moduleName="category"
              actions={{
                showEdit: true,
                showDelete: true,
                showView: false,
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView
              }}
              onStatusChange={handleStatusChange}
            />
        </div>

        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {(limit * (currentPage - 1)) + 1} to {Math.min(limit * currentPage, total)} of {total} Categories
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default CategoryList;
